import React, { Component } from 'react'
import PropTypes from 'prop-types'
import StyleSheet from 'styles'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox'
import IconButton from '@material-ui/core/IconButton'
import DeleteIcon from '@material-ui/icons/Delete'
import CloseIcon from '@material-ui/icons/Close'
import ViewIcon from '@material-ui/icons/Visibility'
import EditIcon from '@material-ui/icons/Edit'
import { ConditionalRender } from 'components'
import Tooltip from '@material-ui/core/Tooltip'
import { SortedTableHead } from 'components'
import { Progress } from 'components/allocation/Progress'
import { Authorization } from 'utils'
import {DateTimeDisplay} from "../DateTimeDisplay";

export class AllocationTable extends Component{

  static propTypes = {
    allocations: PropTypes.array.isRequired
  }

  static defaultProps = {
    onSelectToggle: () => {},
    onAllocationEdit: () => {},
    onAllocationShow: () => {},
    onAllocationDelete: () => {},
    onAllocationRestore: () => {},
    onOrderParamsChange: () => {}
  }

  handleSelectToggle = allocation => event => {
    event.stopPropagation()
    this.props.onSelectToggle(allocation)
  }

  handleAllocationEdit = allocation => event => {
    event.stopPropagation()
    this.props.onAllocationEdit(allocation)
  }

  handleAllocationShow = id => event => {
    event.stopPropagation()
    this.props.onAllocationShow(id)
  }

  handleAllocationDelete = id => event => {
    event.stopPropagation()
    this.props.onAllocationDelete(id)
  }

  handleAllocationRestore = allocation => event => {
    event.stopPropagation()
    this.props.onAllocationRestore(allocation)
  }

  renderAllocation = allocation =>
    <TableRow key={allocation.id} onClick={this.handleSelectToggle(allocation)}>
      <TableCell className={styles('tableSmall','selectCell')}>
        <ConditionalRender requires={Authorization.admin} component={Checkbox} checked={!!this.props.selection[allocation.id]} onClick={this.handleSelectToggle(allocation)}/>
      </TableCell>
      <TableCell className={styles.tableSmall}>
        <div className={styles.investorLabel} >{allocation.investorAccount.accountName}</div>
        <Table className={styles.nestedTable}>
          <TableBody>
            <TableRow>
              <TableCell className={styles.keyCell}>Investor</TableCell>
              <TableCell className={styles.valueCell}>{allocation.investorAccount.accountName}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={styles.keyCell}>Amount</TableCell>
              <TableCell className={styles.valueCell}>{allocation.amount}{allocation.ticker}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={styles.keyCell}>Rate</TableCell>
              <TableCell className={styles.valueCell}>{allocation.rate} {allocation.ticker}/{allocation.currency.code}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={styles.keyCell}>Payment Expected</TableCell>
              <TableCell className={styles.valueCell}>{allocation.paymentExpected}{allocation.currency.code}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={styles.keyCell}>Progress</TableCell>
              <TableCell className={styles.valueCell}><Progress total={allocation.amount} claimed={allocation.amountClaimed} /></TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={styles.keyCell}>Start Date</TableCell>
              <TableCell className={styles.valueCell}><DateTimeDisplay value={allocation.startDate} singleLine/></TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={styles.keyCell}>End Date</TableCell>
              <TableCell className={styles.valueCell}><DateTimeDisplay value={allocation.endDate} singleLine/></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableCell>
      <TableCell>{allocation.amount}</TableCell>
      <TableCell>{allocation.rate} {allocation.ticker}/{allocation.currency.code}</TableCell>
      <TableCell>{allocation.paymentExpected}{allocation.currency.code}</TableCell>
      <TableCell>
        From: <DateTimeDisplay value={allocation.startDate} singleLine/><br/>
        To: <DateTimeDisplay value={allocation.endDate} singleLine/><br/>
      </TableCell>
      <TableCell style={{overflow: 'visible'}}>
        <Progress  total={allocation.amount} claimed={allocation.amountClaimed}/>
      </TableCell>
      <TableCell className={styles.tableSmall}>
        <div className={styles.rowActionButtons}>
          <ConditionalRender requires={Authorization.admin} component={Tooltip} title='Edit'>
            <IconButton style={{height: 24}} onClick={this.handleAllocationEdit(allocation)}>
              <EditIcon/>
            </IconButton>
          </ConditionalRender>
          <Tooltip title='Show'>
            <IconButton style={{height: 24}} onClick={this.handleAllocationShow(allocation.id)}>
              <ViewIcon/>
            </IconButton>
          </Tooltip>
          <ConditionalRender title='Delete' component={Tooltip} requires={Authorization.admin && !allocation.tncsAgreedAt}>
            <IconButton style={{height: 24}} onClick={this.handleAllocationDelete(allocation.id)}>
              <DeleteIcon/>
            </IconButton>
          </ConditionalRender>
          <ConditionalRender title='Close' component={Tooltip} requires={Authorization.admin && allocation.tncsAgreedAt}>
            <IconButton  style={{height: 24}} onClick={this.handleAllocationDelete(allocation.id)}>
              <CloseIcon/>
            </IconButton>
          </ConditionalRender>
        </div>
      </TableCell>
    </TableRow>

  render = () =>
    <Table className={styles.allocationsList} style={{overflow: 'visible'}}>
      <SortedTableHead orderBy={this.props.orderBy} orderDir={this.props.orderDir} onOrderParamsChange={this.props.onOrderParamsChange}>
        <TableRow>
          <TableCell className={styles('tableSmall','selectCell')}></TableCell>
          <TableCell orderBy='investor_accounts.account_name' className={styles.tableSmall}>Investor</TableCell>
          <TableCell orderBy='amount'>Amount</TableCell>
          <TableCell orderBy='unit_price'>Rate</TableCell>
          <TableCell orderBy='payment_expected'>Payment Expected</TableCell>
          <TableCell orderBy='start_date'>Dates</TableCell>
          <TableCell >Progress</TableCell>
          <TableCell className={styles.tableSmall}></TableCell>
        </TableRow>
      </SortedTableHead>
      <TableBody style={{overflow: 'visible'}}>
        {this.props.allocations.map(this.renderAllocation)}
      </TableBody>
    </Table>
}


const styles = StyleSheet({
  selectCell: {
    width: 45,
    padding: 0
  },
  nestedTable: {
    display: 'none',
    tableLayout: 'fixed',
    '@media(max-width: 400px)': {
      width: '0'
    }
  },
  rowActionButtons: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 300,
    '@media(max-width: 600px)': {
      flexDirection: 'column',
    },
    '@media(min-width: 1001px)': {
      paddingLeft: 30,
    }
  },
  allocationsList: {
    '& > tbody > tr:nth-child(odd)': {
      background: 'rgba(0, 0, 0, 0.3)'
    },
    '& > tbody > tr:hover': {
      background: 'rgba(255, 255, 255, 0.1)',
      cursor: 'pointer'
    },
    '& > tbody > tr > td': {
      padding: 0
    },
    '& > thead > tr > th': {
      padding: 0
    },
    '& > tbody > tr > td:last-child': {
      width: 150
    },
    '& > thead > tr > th:last-child': {
      width: 150
    },
    '@media(max-width: 600px)': {
      '& > tbody > tr > td:last-child': {
        width: 50,
        paddingRight: 0,
      },
      '& > thead > tr > th:last-child': {
        width: 50,
        paddingRight: 0,
      },
      tableLayout: 'fixed',
      maxWidth: '100vw'
    }
  },
  '@media(max-width: 1000px)': {
    nestedTable: {
      display: 'table',
      fontSize: 13,
      '& tr': {
        height: 'auto'
      }
    },
    investorLabel: {
      display: 'none'
    },
    allocationsList: {
      '& > tbody > tr > td': {
        display: 'none'
      },
      '& > thead > tr > th': {
        display: 'none'
      }
    }
  },
  keyCell: {
    background: 'rgba(255, 255, 255, 0.1)',
    width: 70,
    textAlign: 'left',
    fontWeight: 'bold',
    borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
    padding: 5
  },
  valueCell: {
    width: 130,
    textOverflow: 'ellipsis',
    padding: '0 5px',
    paddingRight: 5
  },
  tableSmall: {
    display: 'table-cell !important'
  }
})